import React from 'react';
import PropTypes from 'prop-types';
import IconHeroCar from '@spothero/icons/hero-car';
import TabbedSearchControls from 'search/controls/TabbedSearchControls';

const VALUE_PROPS = ['Fast Prepay', 'Mobile Parking Pass', 'Easy Cancellation'];

const HomeHero = ({title}) => (
    <div className="HomeHero">
        <div className="HomeHero-content">
            <header className="HomeHero-header">
                <div className="HomeHero-icon">
                    <IconHeroCar />
                </div>
                <h1>{title}</h1>
            </header>
            <TabbedSearchControls />
        </div>
        <footer className="HomeHero-values">
            <ul>
                {VALUE_PROPS.map(value => (
                    <li className="HomeHero-value" key={value}>
                        <span>{value}</span>
                    </li>
                ))}
            </ul>
        </footer>
    </div>
);

HomeHero.propTypes = {
    title: PropTypes.string,
};

HomeHero.defaultProps = {
    title: `Let's Find Your Spot`,
};

export default HomeHero;
